import SelectOption from "../SelectOption";

export enum UserRole {
    Importacao = 1,
    HistoricoImportacao = 2,
    ParametrizacaoPlanoAtividade = 3,
    PlanoAtividade = 4,
    AssociacaoProfessorCoordenador = 6,
    AssociacaoAtividadeProfessor = 7,
    GestaoUsuario = 8,
    Workflow = 9,
    GestaoPermissaoPlanoAtividade = 10,
    GestaoCalendario = 11,
    AgendaDocente = 12,
    EditarAgendaDocente = 13,
    VisualizarAgendaDocente = 14,
    VisualizarPlanoAtividade = 15,
    PlanoAtividadeDocente = 16,
    EditarPlanoAtividadeDocente = 17,
    ParametrizacaoCheckin = 18,
    GestaoAbonoLegal = 19,
    GestaoWorkflow = 20,
    Relatorios = 21,
    Help = 22,
    TermoAceite = 23,
    AdministradorTach = 24,
    HistoricoTach = 25,
    Home = 26,
    MeuPainelMenu = 27,
    MeuPainelDocente = 28,
}

const UserRoleLabel = new Map<UserRole, string>([
    [UserRole.Importacao, "TELA_IMPORTACAO"],
    [UserRole.HistoricoImportacao, "TELA_HISTORICO_IMPORTACAO"],
    [
        UserRole.ParametrizacaoPlanoAtividade,
        "TELA_PARAMETRIZACAO_PLANO_ATIVIDADE",
    ],
    [UserRole.PlanoAtividade, "TELA_PLANO_ATIVIDADE"],
    [
        UserRole.AssociacaoProfessorCoordenador,
        "TELA_ASSOCIACAO_PROFESSOR_COORDENADOR",
    ],
    [
        UserRole.AssociacaoAtividadeProfessor,
        "TELA_ASSOCIACAO_ATIVIDADE_PROFESSOR",
    ],
    [UserRole.GestaoUsuario, "TELA_GESTAO_USUARIO"],
    [UserRole.Workflow, "TELA_WORKFLOW"],
    [
        UserRole.GestaoPermissaoPlanoAtividade,
        "TELA_GESTAO_PERMISSAO_PLANO_ATIVIDADE",
    ],
    [UserRole.GestaoCalendario, "TELA_GESTAO_CALENDARIO"],
    [UserRole.AgendaDocente, "TELA_AGENDA_DOCENTE"],
    [UserRole.EditarAgendaDocente, "TELA_EDITAR_AGENDA_DOCENTE"],
    [UserRole.VisualizarAgendaDocente, "TELA_VISUALIZAR_AGENDA_DOCENTE"],
    [UserRole.VisualizarPlanoAtividade, "TELA_VISUALIZAR_PLANO_ATIVIDADE"],
    [UserRole.PlanoAtividadeDocente, "TELA_PLANO_ATIVIDADE_DOCENTE"],
    [
        UserRole.EditarPlanoAtividadeDocente,
        "TELA_EDITAR_PLANO_ATIVIDADE_DOCENTE",
    ],
    [UserRole.ParametrizacaoCheckin, "TELA_PARAMETRIZACAO_CHECKIN"],
    [UserRole.GestaoAbonoLegal, "TELA_GESTAO_ABONO_LEGAL"],
    [UserRole.GestaoWorkflow, "TELA_GESTAO_WORKFLOW"],
    [UserRole.Relatorios, "TELA_RELATORIOS"],
    [UserRole.Help, "UPLOAD_DOCUMENTO_HELP"],
    [UserRole.TermoAceite, "TELA_TERMO_ACEITE"],
    [UserRole.AdministradorTach, "TELA_ADMINISTRADOR_TACH"],
    [UserRole.HistoricoTach, "TELA_HISTORICO_TACH"],
    [UserRole.Home, "TELA_HOME"],
    [UserRole.MeuPainelMenu, "MENU_MEU_PAINEL"],
    [UserRole.MeuPainelDocente, "TELA_MEU_PAINEL_DOCENTE"],
]);

export const getOptionsUserRole = () => {
    const enumList = Array.from(UserRoleLabel).map((item: any) => {
        return {
            value: String(item.at(0)),
            label: item.at(1),
        } as SelectOption;
    });

    return enumList?.sort((a, b) => a.label.localeCompare(b.label));
};

export const getLabelRoleEnum = (value: UserRole | null) => {
    if (!value) return "";

    return UserRoleLabel.get(value);
};

export const getValueTRoleEnum = (label: string) => {
    const value = getOptionsUserRole()?.find(
        (item) => item?.label?.toLowerCase() === label?.toLowerCase()
    )?.value;
    return Number(value);
};

export const getUserRoleEnumFromNumber = (number: number): UserRole | null => {
    const enumValues = Object.values(UserRole);
    const enumValue = enumValues.find((value) => value === number) as
        | UserRole
        | undefined;

    return enumValue ?? null;
};
